import {
  USER_ACTIVITIES_CHANGE_VALUE,
  USER_ACTIVITIES_CHANGE_TABLE_OPTION,
  USER_ACTIVITIES_CHANGE_VALUES,
} from '@/store/constants/mutationTypes';
import initialState from './userActivitiesInitialState';

const mutations = {
  [USER_ACTIVITIES_CHANGE_VALUE]: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state[field] = value;
  },
  [USER_ACTIVITIES_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
  [USER_ACTIVITIES_CHANGE_TABLE_OPTION]: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state.uaTableOptions[field] = value;
  },
};

export default mutations;
